export default [
  {
    path: '/logowanie',
    component: () => import('@/components/auth/Login')
  }
]
